import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  AppMobileDevices,
  AppMobileDevicesModel,
  Environment,
  IsError,
  ModelBoolStr,
  NotificheTokenPersone,
} from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class AppMobileDevicesService extends CrudGenericsService<AppMobileDevices, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/AppMobileDevices`);
    this.base = `${env.apiUrl}/api/AppMobileDevices/`;
  }
  // web   tabella
  GetAllTableModel(): Observable<AppMobileDevicesModel[]> {
    const u = `${this.base}GetAllTableModel`;
    return this.http.get<AppMobileDevicesModel[]>(u);
  }
  // i
  // ionic info licenze disponibili
  InfoLicMaxDevicesIsFull(): Observable<ModelBoolStr> {
    const u = `${this.base}InfoLicMaxDevicesIsFull`;
    return this.http.get<ModelBoolStr>(u);
  }
  // ionic metodo principale aggiunge everifica licenza
  CheckAndSync_LicMaxDevices(model: AppMobileDevices): Observable<IsError> {
    const u = `${this.base}CheckAndSync_LicMaxDevices`;
    return this.http.post<IsError>(u, model);
  }
  // simile a CheckAndSync_LicMaxDevices cambia modello di input e non scrive sul database
  // ionic allo start verifica se puo' inscriversi per il push notification
  CheckCanSubscribeToPushMobile_ByNotTokPer(model: NotificheTokenPersone): Observable<IsError> {
    const u = `${this.base}CheckCanSubscribeToPushMobile_ByNotTokPer`;
    return this.http.post<IsError>(u, model);
  }
}
